export default __webpack_public_path__ + "assets/images/f75c69f7078c3aa1a734706614ca8f18.jpg";